export default __webpack_public_path__ + "static/media/comment.49d55f76.svg";